<template>
  <v-dialog
      ref="dialog"
      v-model="open"
      :return-value.sync="date"
      persistent
      width="290px"
  >
    <v-card>

      <v-card-text class="pa-2">
        <v-date-picker
            v-model="date"
            locale="th"
            scrollable
        >
        </v-date-picker>
        <div class="container">
          <div class="row">
            <div class="col-3">
              <v-btn
                  class="" color="primary" fab small
                  @click="alterTime(-30)">
                <v-icon>mdi-minus</v-icon>
              </v-btn>
            </div>
            <div class="col-6">
              <v-select
                  class=""
                  v-model="time"
                  label="เวลา"
                  :items="time_selector"
                  hide-details
                  outlined
                  required
              >
              </v-select>
            </div>
            <div class="col-3">
              <v-btn
                  class="" color="primary" fab small
                  @click="alterTime(30)">
                <v-icon>mdi-plus</v-icon>
              </v-btn>
            </div>
          </div>
        </div>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
            color="primary"
            text
            @click="open = false"
        >
          Cancel
        </v-btn>
        <v-btn
            color="primary"
            text
            @click="doApply()"
        >
          OK
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>


<script lang="ts">

import {date_format_mysql} from '@/services/Helper'
import moment from 'moment-timezone'
import {Component, Vue} from 'vue-property-decorator'


@Component({
  components: {}
})
export default class DatePicker extends Vue {

  open: boolean = false
  datetime: Date = new Date()
  date = ''
  time = ''
  time_selector = [
    '00:00', '00:30', '01:00', '01:30', '02:00', '02:30', '03:00', '03:30',
    '04:00', '04:30', '05:00', '05:30', '06:00', '06:30', '07:00', '07:30',
    '08:00', '08:30', '09:00', '09:30', '10:00', '10:30', '11:00', '11:30',
    '12:00', '12:30', '13:00', '13:30', '14:00', '14:30', '15:00', '15:30',
    '16:00', '16:30', '17:00', '17:30', '18:00', '18:30', '19:00', '19:30',
    '20:00', '20:30', '21:00', '21:30', '22:00', '22:30', '23:00', '23:30'
  ]
  onApply: Function = () => {
  }

  alterTime(mins){
    let tmpTime = moment('2000-01-01 '+this.time)
    this.time = tmpTime.add('minutes',mins).format('HH:mm')
  }
  doApply() {
    this.datetime = new Date(this.date + 'T' + this.time + '+0700')
    this.onApply(this.datetime)
    this.open = false
  }

  created() {
    this.$root.$on('openDateTimePicker', this.onOpen)
  }

  onOpen({datetime, onApply}) {
    if (this.open) return
    console.log('Emited', {datetime})
    if (datetime) {
      this.datetime = datetime
    }

    this.date = moment(this.datetime).tz('Asia/Bangkok').format('YYYY-MM-DD')
    this.time = moment(this.datetime).tz('Asia/Bangkok').format('HH:mm')
    this.open = true

    this.onApply = onApply
  }

};

</script>
